'use strict';

module.exports = function(ngModule) {
  require('./home')(ngModule);
  require('./about')(ngModule);
  require('./contact')(ngModule);
  require('./unknown')(ngModule);
  require('./landing')(ngModule);
  require('./auth')(ngModule);
  require('./onsite')(ngModule);
  require('./messages')(ngModule);
};
